import React from 'react';
import { ChangelogListing } from 'modules/stages';
import { PageContainer } from 'components/shared/Page/PageContainer';

export const AuditLog = () => {
  return (
    <PageContainer title="Audit Log">
      <ChangelogListing />
    </PageContainer>
  );
};
